var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMillionDollarBonusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.571,
    height: 25.062,
    viewBox: "0 0 67.571 25.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(-1038.977 -1454.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M8.7.541,6.718,4.568l-4.444.648a.974.974,0,0,0-.538,1.661l3.215,3.133-.76,4.425A.973.973,0,0,0,5.6,15.459L9.577,13.37l3.975,2.089a.973.973,0,0,0,1.411-1.025l-.76-4.425,3.215-3.133a.974.974,0,0,0-.538-1.661l-4.444-.648L10.45.541A.974.974,0,0,0,8.7.541Z",
    transform: "translate(1037.535 1463.746)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-2",
    "data-name": "Icon awesome-star",
    d: "M13.126.871l-3.2,6.478L2.782,8.391a1.567,1.567,0,0,0-.866,2.672L7.088,16.1,5.865,23.222a1.565,1.565,0,0,0,2.27,1.649l6.4-3.362,6.4,3.362a1.566,1.566,0,0,0,2.27-1.649L21.973,16.1l5.172-5.04a1.567,1.567,0,0,0-.866-2.672L19.13,7.349,15.935.871a1.567,1.567,0,0,0-2.809,0Z",
    transform: "translate(1058.231 1454.258)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-3",
    "data-name": "Icon awesome-star",
    d: "M8.7.541,6.718,4.568l-4.444.648a.974.974,0,0,0-.538,1.661l3.215,3.133-.76,4.425A.973.973,0,0,0,5.6,15.459L9.577,13.37l3.975,2.089a.973.973,0,0,0,1.411-1.025l-.76-4.425,3.215-3.133a.974.974,0,0,0-.538-1.661l-4.444-.648L10.45.541A.974.974,0,0,0,8.7.541Z",
    transform: "translate(1088.834 1463.746)",
    fill: "#3d3d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillionDollarBonusIcon);
export default __webpack_public_path__ + "static/media/million-dollar-bonus-icon.c4ad82ab04086d9371952753cdf58a02.svg";
export { ForwardRef as ReactComponent };